// A small inline spinner for in-progress button states -- one shared implementation so every
// "Save"/"Sign in"/"Erase" button in the admin panel shows the same busy indicator instead of
// each screen inventing its own (or, as several did, showing none at all).
export default function Spinner({ className = "size-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={`${className} animate-spin`} aria-hidden>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
